var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canViewRealtime)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","height":"100%"}},[_c('realtime-roster',{style:(_vm.rosterStyle)}),_c('realtime-view',{staticStyle:{"flex-grow":"1"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }